import { render } from "./FlaggedIcon.vue?vue&type=template&id=e2a421b8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/FlaggedIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2a421b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2a421b8', __exports__)) {
    api.reload('e2a421b8', __exports__)
  }
  
  module.hot.accept("./FlaggedIcon.vue?vue&type=template&id=e2a421b8", () => {
    api.rerender('e2a421b8', render)
  })

}


export default __exports__